import { configureStore } from '@reduxjs/toolkit'
import { authReducer, kpisReducer, plantReducer, rolesReducer, utilsReducer, logsReducer, dynamicAdjustmentsReducer,productionLineReducer } from "../features";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    plant: plantReducer,
    utils: utilsReducer,
    kpis: kpisReducer,
    roles: rolesReducer,
    logs: logsReducer,
    dynamicAdjustments: dynamicAdjustmentsReducer,
    productionLine: productionLineReducer
  },
})
